import { render } from "./SunProtectionTips.vue?vue&type=template&id=b4762c5a&scoped=true"
import script from "./SunProtectionTips.vue?vue&type=script&lang=js"
export * from "./SunProtectionTips.vue?vue&type=script&lang=js"

import "./SunProtectionTips.vue?vue&type=style&index=0&id=b4762c5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4762c5a"]])

export default __exports__